import type { PropsWithChildren, ReactElement } from "react";

import { ArrowDown } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import type { ListsDropdownButtonProps } from "app/pages/sales-intelligence/sub-modules/opportunities/components/top-section/ListsDropdown/types";

import { StyledPageTitleButton } from "./styles";

type Props = PropsWithChildren<Omit<ListsDropdownButtonProps, "list" | "onClick"> & { onClick?: () => void }>;

const PageTitleButton = ({ children, onClick }: Props): ReactElement => {
    return (
        <StyledPageTitleButton
            onClick={onClick}
            withHover={!!onClick}
        >
            {children}

            {onClick ? (
                <ArrowDown
                    color={colorsPalettes.carbon[200]}
                    size="sm"
                />
            ) : null}
        </StyledPageTitleButton>
    );
};

export default PageTitleButton;
